/**
 * Code generated by "npm run build-assets"
 * Figma URL: https://nda.ya.ru/t/szoozwps6Uejh3
 */

import {ImageAssetMeta, SrcSet} from '@yandex-delivery/assets'

import img1x from './cargo@1x.png'
import img2x from './cargo@2x.png'
import img3x from './cargo@3x.png'

export const cargo: ImageAssetMeta = {
  width: 40,
  height: 80,
  srcSet: new SrcSet(img1x, img2x, img3x),
}
